








import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'icon-contrast',
  components: {}
}

@Component(config)
export default class IconContrast extends Vue {}
